const initialState = {
  loadingJanela: false,
  loadingSubmit: false,
  janela: null,
  error: null
}

export default function aprovaracaoReducer(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_JANELA_CHECK_REQUEST':
      return {
        ...state,
        loadingJanela: true,
        janela: null,
        error: null
      }

    case 'FETCH_JANELA_CHECK_SUCCESS':
      return {
        ...state,
        loadingJanela: false,
        janela: action.payload || null,
        error: null
      }

    case 'FETCH_JANELA_CHECK_FAILURE':
      return {
        ...state,
        loadingJanela: false,
        error: action.payload || true
      }

    case 'APROVAR_ACAO_REQUEST':
      return {
        ...state,
        loadingSubmit: true,
        error: null
      }

    case 'APROVAR_ACAO_SUCCESS':
      return {
        ...state,
        loadingSubmit: false,
        error: null
      }

    case 'APROVAR_ACAO_FAILURE':
      return {
        ...state,
        loadingSubmit: false,
        error: action.payload || true
      }

    case 'CLEAR_APROVAR_ACAO':
      return initialState

    default:
      return state
  }
}